<template>
  <modal @close="close">
    <template #body>
      <div class="modal-auth">
        <!--                <div class="modal-auth__title">Быстрый вход / регистрация</div>-->
        <!--                <div class="modal-auth__head">-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="vk"></IconDef>-->
        <!--                        ВК ID-->
        <!--                    </NuxtLink>-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="yandex"></IconDef>-->
        <!--                        Яндекс ID-->
        <!--                    </NuxtLink>-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="sber"></IconDef>-->
        <!--                        Сбер ID-->
        <!--                    </NuxtLink>-->
        <!--                </div>-->
        <div class="modal-auth__social">
          <a :href="yandexAuthUrl" class="modal-auth__social-btn modal-auth__social-btn--yandex">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path fill="currentColor" d="M13.643 6.778h-.92c-1.658 0-2.532.838-2.532 2.2 0 1.55.634 2.266 1.955 3.143L13.3 13.18l-4.064 6.153H6.9l3.713-5.603C8.9 12.42 7.838 11.094 7.838 8.834c0-2.869 1.98-4.612 5.174-4.612H16.1V19.33h-2.457V6.778z"/></svg>
            Войти через Яндекс
          </a>
        </div>
        <div class="modal-auth__or">или</div>
        <div class="modal-auth__form">
          <form action="">
            <Input
              placeholder="Введите ваше имя"
              name="login"
              type="text"
              class="input input-full"
              v-model="name"
              v-if="isReg && !showPassword"
            />
            <Input
              placeholder="Введите ваш email"
              name="login"
              type="text"
              class="input input-full"
              v-model="email"
              v-if="!showPassword"
            />
            <Input
              placeholder="Введите ваше телефон"
              name="login"
              type="text"
              class="input input-full"
              v-model="phone"
              v-if="isReg && !showPassword"
            />
            <div class="modal-auth__code-hint" v-if="showPassword">
              Код отправлен на {{ email }}
            </div>
            <Input
              v-if="showPassword"
              placeholder="Введите код из письма"
              name="pass"
              type="password"
              class="input input-full"
              v-model="password"
            />
            <Button
              :title="authBtnLabel"
              class="full-dark-btn"
              type="button"
              @click.prevent="auth"
            ></Button>
            <Checkbox
              :label="agreementLabel"
              :isCheck="false"
              name="agreement_politic"
            />
            <Checkbox
              :label="ofertaLabel"
              :isCheck="false"
              name="oferta_politic"
            />
            <Checkbox
              :label="adofertaLabel"
              :isCheck="false"
              name="adoferta_politic"
            />
            <Button
              :title="switchBtnLabel"
              class="full-white-btn"
              type="button"
              @click.prevent="switchMode"
            ></Button>
          </form>
          <!--                    <div class="modal-auth__form-text">или отправить ссылку на уроки</div>-->
        </div>
        <!--                <div class="modal-auth__foot">-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="whatsapp"></IconDef>-->
        <!--                        WhatsApp-->
        <!--                    </NuxtLink>-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="tele"></IconDef>-->
        <!--                        Telegram-->
        <!--                    </NuxtLink>-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="mail"></IconDef>-->
        <!--                        E-mail-->
        <!--                    </NuxtLink>-->
        <!--                    <NuxtLink>-->
        <!--                        <IconDef name="sms"></IconDef>-->
        <!--                        SMS-->
        <!--                    </NuxtLink>-->
        <!--                </div>-->
        <!--                <Button title="Укажите номер WhatsApp" class="full-white-btn"></Button>-->
      </div>
    </template>
  </modal>
</template>

<style scoped>
.modal-auth__social { margin-bottom: 0; }
.modal-auth__social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: opacity 0.18s;
  cursor: pointer;
}
.modal-auth__social-btn:hover { opacity: 0.85; }
.modal-auth__social-btn--yandex { background: #fc3f1d; color: #fff; }
.modal-auth__or {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 18px 0 14px;
  font-size: 13px;
  color: #aaa;
}
.modal-auth__or::before,
.modal-auth__or::after { content: ''; flex: 1; height: 1px; background: #e8e8e8; }
.modal-auth__code-hint {
  margin-bottom: 10px;
  font-size: 13px;
  color: #777;
}
</style>

<script setup>
import Checkbox from "~/components/UI/btn/Checkbox.vue";
import Button from "~/components/UI/btn/Button.vue";
import Input from "~/components/UI/inputs/Input.vue";
import modal from "~/components/UI/Modal.vue";
import IconDef from "~/components/UI/IconDef.vue";
import api from "~/api/api.js";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleVisible: {
    type: Boolean,
    default: true,
  },
});
const emit = defineEmits(["close"]);

const YANDEX_CLIENT_ID = '4bf5d078cd1b405caa0d7e3d6442567a'
const YANDEX_REDIRECT_URI = 'https://sharun.store'
// `state` carries the subdomain the login started from, so the apex-domain
// callback can hand the (already cross-subdomain) session cookie back to it.
const yandexState = useRequestURL().origin
const yandexAuthUrl = `https://oauth.yandex.ru/authorize?response_type=code&client_id=${YANDEX_CLIENT_ID}&redirect_uri=${encodeURIComponent(YANDEX_REDIRECT_URI)}&state=${encodeURIComponent(yandexState)}`

const showPassword = ref(false);
const email = ref("");
const password = ref("");
const name = ref("");
const phone = ref("");
const isReg = ref(false);

const authBtnLabel = computed(() =>
  isReg.value ? "Зарегистрироваться" : "Войти",
);
const switchBtnLabel = computed(() => (isReg.value ? "Вход" : "Регистрация"));
let agreementLabel =
  'Я соглашаюсь с <a href="/privacy/">политикой конфиденциальности</a>';

let ofertaLabel =
  'Я принимаю с <a href="/oferta/">пользовательское соглашение</a>';

let adofertaLabel =
  'Согласие на <a href="/adoferta/">рассылку от Шарунстор</a>';

const close = () => {
  emit("close");
  count.value = 0;
};

function switchMode() {
  isReg.value = !isReg.value;
  showPassword.value = false;
  password.value = "";
}

function auth() {
  if (isReg.value) reg();
  else login();
}

async function login() {
  if (!email.value) return;

  const formData = new FormData();
  formData.append("login", email.value);
  if (showPassword.value) formData.append("password", password.value);

  let data;
  try {
    data = await api("/login", formData, "POST");
  } catch (error) {
    if (error === "code") {
      alert("Пароль был выслан на вашу почту");
      showPassword.value = true;
    } else if (error === "invalid_code" || error === "invalid_user") {
      alert("Неверные почта/пароль");
    } else if (error === "mail_failed") {
      alert("Не удалось отправить код на почту. Попробуйте позже или войдите через Яндекс.");
    } else {
      alert("Не удалось войти. Попробуйте ещё раз или войдите через Яндекс.");
    }

    return;
  }

  localStorage.setItem("Id", data.id);
  localStorage.setItem("Token", data.token);
  location.reload();
}

async function reg() {
  if (!name.value || !email.value || !phone.value) return;

  const formData = new FormData();
  formData.append("name", name.value);
  formData.append("email", email.value);
  formData.append("send", Number(!showPassword.value));
  formData.append("phone", phone.value);
  if (showPassword.value) formData.append("password", password.value);

  let data;
  try {
    data = await api("/register", formData, "POST");
  } catch (error) {
    if (error === "code") {
      alert("Пароль был выслан на вашу почту");
      showPassword.value = true;
    } else if (error === "invalid_code") {
      alert("Неверный пароль");
    } else if (error === "exists" || error === "error") {
      alert("Данный email уже зарегистрирован");
    } else if (error === "mail_failed") {
      alert("Не удалось отправить код на почту. Попробуйте позже или войдите через Яндекс.");
    } else {
      alert("Не удалось зарегистрироваться. Попробуйте ещё раз или войдите через Яндекс.");
    }

    return;
  }

  localStorage.setItem("Id", data.id);
  localStorage.setItem("Token", data.token);
  location.reload();
}
</script>
